module.exports = __webpack_public_path__ + "img/image_barcode.52717620.jpeg";